import { Namespace } from '_core/utils/ssr';

export const storyConfig = {
  i18nNamespaces: ['common', 'story', 'stories'] as Namespace,
};
